<template>
  <div>
    <crumb-tit>
      <!-- 信息分配配置 -->
      <span slot="breadTit">{{ $t('message["1362"]') }}</span>
      <span slot="secondTit">{{ $t('message["1362"]') }}</span>
    </crumb-tit>
    <div class="alloication-tip-t">
      <a-alert
        :message="infoSetTipTxt"
        type="warning"
        show-icon
      />
    </div>
    <div
      class="notice-setting-box"
    >
      <a-tabs
        v-model="active"
        :animated="false"
        @change="handleClick"
      >
        <a-tab-pane
          key="setmethod"
        >
          <span slot="tab">
            <!-- 分配方式 -->
            {{ $t('message["300"]') }}
            <a-popover
              placement="bottomLeft"
              overlay-class-name="in-tip-class"
            >
              <template slot="content">
                <p style="color:#999;">{{ $t('message["9"]') }}</p>
              </template>
              <i class="iconfont iconicon-test30" />
            </a-popover>
          </span>
          <!-- 分配方式-模块内容 -->
          <set-method />
        </a-tab-pane>
        <a-tab-pane
          key="setrule"
        >
          <span slot="tab">
            <!-- 分配规则 -->
            {{ $t('message["301"]') }}
            <a-popover
              placement="bottomLeft"
              overlay-class-name="in-tip-class"
            >
              <template slot="content">
                <p style="color:#999;"> {{ $t('message["1539"]') }}</p>
              </template>
              <i class="iconfont iconicon-test30" />
            </a-popover>
          </span>
          <!-- 分配规则-模块内容 -->
          <allocationRule />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
import AllocationRule from './allocationrule/AllocationRule'
import SetMethod from './allocationrule/SetMethod'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  components: {
    CrumbTit,
    AllocationRule,
    SetMethod
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  inject: ['reload'],
  data () {
    return {
      active: 'setmethod'
    }
  },
  computed: {
    ...mapState('config/allocationrule', ['activeName', 'listDatasReady']),
    routeQuery () {
      return this.$route.query
    },
    infoSetTipTxt () {
      return this.$t('message["568"]')
    }
  },
  beforeRouteLeave (to, from, next) {
    this.setAllListDataObj({})
    this.setListDatasReady(false)
    next()
  },
  watch: {
    async active (val) {
      const chain = await this.fetchAllocationListDatas()
      chain.fetch()
      await this.getAuthTeamInfo2()
      // this.reload()
    }
  },
  async created () {
    this.active = this.activeName
    this.setActiveName(this.routeQuery.tab)
    this.active = this.routeQuery.tab
    if (!this.routeQuery.groupid && !this.routeQuery.roleid) {
      const chain = await this.fetchAllocationListDatas()
      chain.onSuccess(raw => {
      })
        .fetch()
    }
  },
  methods: {
    ...mapMutations('config/allocationrule', ['setActiveName', 'setAllListDataObj', 'setListDatasReady']),
    ...mapActions('config/allocationrule', ['fetchAllocationDatas', 'fetchAllocationListDatas', 'getAuthTeamInfo2']),
    handleClick (e) {
      this.setActiveName(e)
      this.$router.push({ name: 'configRule', query: { tab: e } })
    }
  }
}
</script>
<style lang="scss" scoped>
  .alloication-tip-t::v-deep {
    margin: 24px 0 16px;
    .ant-alert-warning{
      background: #FFF4E7;
      border: 1px solid #F6A953;
      border-radius: 4px;
    }
  }
   .notice-setting-box::v-deep {
    border-top: 1px solid #ebebeb;
    font-size: 18px;
    margin-top: 16px;
    .ant-tabs-bar {
      border-bottom: none 0;
    }
    .ant-tabs-nav .ant-tabs-tab {
      font-size: 18px;
      font-weight: bold;
      padding: 12px 2px;
    }
    .iconicon-test30 {
    color: #b3b3b3;
  }
  }
</style>
